import { FC } from "react";
import { Circle, Container, Loader } from "./CircularProgress.styled";
import { useTranslation } from "../../../hooks/useTranslation";

type Props = {
  value: number;
};

export const CircularProgress: FC<Props> = ({ value }) => {
  const { t } = useTranslation();

  return (
    <Container>
      <Circle value={value} />
      <Loader>
        {t("completedProgress")}: <span>{value}%</span>
      </Loader>
    </Container>
  );
};
